var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showIframe)?_c('iframe',{staticStyle:{"z-index":"10","height":"calc(100vh - 111px)"},attrs:{"frameborder":"0","width":"100%","title":"Báo cáo thống kê","src":_vm.urlIframe}}):_vm._e(),_c('a',{attrs:{"href":_vm.urlIframe,"target":"_blank","rel":"noopener noreferrer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }